"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _replace2 = _interopRequireDefault(require("lodash/replace"));
var _compact2 = _interopRequireDefault(require("lodash/compact"));
var _defaultTo2 = _interopRequireDefault(require("lodash/defaultTo"));
var _upperCase2 = _interopRequireDefault(require("lodash/upperCase"));
var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _omitBy2 = _interopRequireDefault(require("lodash/omitBy"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));
var _join2 = _interopRequireDefault(require("lodash/join"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isNull2 = _interopRequireDefault(require("lodash/isNull"));
var _default = {
  /**
   *
   * @param flight
   * @param pos
   * @param list
   * @param quantity
   */
  itineraryToGaProduct: function itineraryToGaProduct(flight) {
    var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var list = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var quantity = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if ((0, _isNull2["default"])(flight) || (0, _isEmpty2["default"])(flight)) return {};
    var flightIds = flight.flightCodes.join(' ');
    var flightProduct = {
      id: flightIds,
      name: "".concat(flight.vendor.toUpperCase(), " Flight ").concat(flightIds),
      category: 'Air',
      brand: (0, _join2["default"])((0, _flatMap2["default"])(flight.uniqueCarriers, 'validatingCarrier'), ' '),
      price: flight.totalPrice,
      list: list,
      pos: pos,
      quantity: quantity || (0, _get2["default"])(flight.attribute, 'pax.totalSeats', null)
    };
    return (0, _omitBy2["default"])(flightProduct, _isNil2["default"]);
  },
  /**
   *
   * @param flight
   * @param airports
   * @returns {{leg: Array}}
   */
  flightProductToSearchInfo: function flightProductToSearchInfo(flight) {
    var airports = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if ((0, _isNull2["default"])(flight) || (0, _isEmpty2["default"])(flight)) return {};
    var language = window.config.language;
    return {
      leg: (0, _map2["default"])(flight.flightLegs, function (flight) {
        return (0, _assign2["default"])(flight, {
          originCity: (0, _get2["default"])(airports, "".concat(flight.originId, ".city.").concat(language), null),
          destinationCity: (0, _get2["default"])(airports, "".concat(flight.destinationId, ".city.").concat(language), null)
        });
      })
    };
  },
  /**
   * transform flight product to GA format
   * @param flight
   * @returns {{id, name: string, category: string, brand, price, quantity}}
   */
  flightProductToGaProduct: function flightProductToGaProduct(flight) {
    if ((0, _isNull2["default"])(flight) || (0, _isEmpty2["default"])(flight)) return {};
    var flightIds = (0, _join2["default"])(flight.options.flightCodes, ' ');
    return {
      id: flightIds,
      name: "".concat((0, _upperCase2["default"])(flight.vendorName), " Flight ").concat(flightIds),
      category: 'Air',
      brand: (0, _join2["default"])((0, _flatMap2["default"])(flight.flightLegs, 'validatingCarrier'), ' '),
      price: (0, _get2["default"])(flight.price, 'total', 0),
      quantity: (0, _get2["default"])(flight.options, 'pax.length', 1)
    };
  },
  /**
   *
   * @param hotel
   * @param pos
   * @param list
   * @param quantity
   * @returns {{}}
   */
  hotelsToGaProduct: function hotelsToGaProduct(hotel) {
    var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var list = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var quantity = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if ((0, _isNull2["default"])(hotel) || (0, _isEmpty2["default"])(hotel)) return {};
    var hotelProduct = {
      id: hotel.id,
      name: hotel.hotelName,
      category: 'Hotel',
      brand: hotel.hotelName,
      highRate: hotel.highRate,
      lowRate: hotel.lowRate,
      list: list,
      pos: pos,
      quantity: quantity
    };
    return (0, _omitBy2["default"])(hotelProduct, _isNil2["default"]);
  },
  /**
   *
   * @param hotel
   * @param position
   * @param list
   * @returns {{quantity: *, name: *, highRate: *, lowRate: *, id: *, position: *, category: *, list: *, brand: *}}
   */
  getHotelGaProduct: function getHotelGaProduct(hotel, position, list) {
    if ((0, _isNull2["default"])(hotel) || (0, _isEmpty2["default"])(hotel)) return {};
    var _position = (0, _defaultTo2["default"])(position, 0);
    var _list = (0, _defaultTo2["default"])(list, 'Hotel Search Results');

    // category as
    return {
      id: (0, _get2["default"])(hotel, 'id', (0, _get2["default"])(hotel, 'hotelId', null)),
      name: (0, _get2["default"])(hotel, 'hotelName', (0, _get2["default"])(hotel, 'hotelNameEn', null)),
      category: this.generateHotelCategory(hotel),
      brand: (0, _get2["default"])(hotel, 'chain', (0, _get2["default"])(hotel, 'chainCode', null)),
      list: _list,
      position: _position,
      lowRate: (0, _get2["default"])(hotel, 'lowRate', null),
      highRate: (0, _get2["default"])(hotel, 'highRate', null),
      quantity: (0, _get2["default"])(hotel, 'quantity', (0, _get2["default"])(hotel, 'room.length', 1))
    };
  },
  /**
   *
   * @param hotel
   * @returns {string}
   */
  generateHotelCategory: function generateHotelCategory(hotel) {
    return (0, _join2["default"])((0, _compact2["default"])((0, _map2["default"])([hotel.country, hotel.city, hotel.stars, hotel.district, hotel.chain], function (prop) {
      return (0, _replace2["default"])((0, _replace2["default"])(prop, '/', '_'), ' ', '-');
    })), '/');
  }
};
exports["default"] = _default;